var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.136 99.235c0-.36-.266-.652-.588-.652h-8.816c-.327 0-.589.292-.589.652v3.466h9.993v-3.466",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.327 77.855H15.022v24.847h5.121v-1.36h-3.192V79.785h35.446v21.555H30.136v1.36h24.19V77.856",
    style: {
      fill: "#7e7f81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.125 89.488.23-.285c.185-.224.437-.363.704-.407a1.12 1.12 0 0 1 1.297.935 1.09 1.09 0 0 1-.227.888l-2.184 2.734c-.16.213-.13.51.084.678.104.09.25.12.38.099l.01-.002.008-.002 3.06-.496a.474.474 0 0 0 .398-.552.48.48 0 0 0-.554-.407l-1.84.297 1.392-1.743a2.096 2.096 0 0 0 .433-1.65 2.073 2.073 0 0 0-.761-1.305 2.106 2.106 0 0 0-1.65-.434 2.085 2.085 0 0 0-1.305.764l-.23.284a.486.486 0 0 0 .077.68c.212.17.51.14.678-.076m15.658-2.54.229-.287c.186-.225.44-.363.705-.407.304-.05.624.014.89.229.224.183.362.43.407.706.05.31-.015.626-.228.889l-2.181 2.73a.487.487 0 0 0 .082.681c.103.09.25.119.38.099l.008-.001.008-.002 3.062-.497a.476.476 0 0 0 .399-.553.481.481 0 0 0-.554-.406l-1.843.299 1.394-1.745a2.11 2.11 0 0 0 .434-1.65 2.073 2.073 0 0 0-.763-1.305 2.116 2.116 0 0 0-1.651-.433 2.067 2.067 0 0 0-1.305.762l-.228.286a.483.483 0 0 0 .075.68.479.479 0 0 0 .68-.075m-7.98 3.344 1.229-.198.194 1.203a.494.494 0 0 0 .574.412.5.5 0 0 0 .412-.572l-.195-1.202 1.227-.2a.482.482 0 0 0-.152-.95l-1.23.199-.195-1.202a.499.499 0 1 0-.986.158l.195 1.204-1.228.197a.49.49 0 0 0-.398.554.48.48 0 0 0 .553.397",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.327 102.702H15.022V77.855h39.305Zm.703-27.455H14.32c-1.05 0-1.908.81-1.908 1.808v25.974h44.526V77.055c0-.997-.856-1.808-1.908-1.808",
    style: {
      fill: "#d3d4d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.95 101.341h3.193v-2.106c0-.36.262-.652.589-.652h8.816c.322 0 .588.292.588.652v2.106h22.261V79.786H16.951v21.555",
    style: {
      fill: "#a8a9ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.812 103.029H10.943c-.361 0-.653.166-.653.371v1.539c0 .205.292.371.653.371H55.03c1.052 0 1.908-.81 1.908-1.809v-.472h-1.126",
    style: {
      fill: "#a7a9ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.592 124.896H19.85v-13.899h1.742v13.899",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5666.238 773.105 102.016 22.02c-20.477-150.9-40.579-241.72-44.243-279.57h-45.226c.14 57.15-11.801 171.93-12.547 257.55m-25.996 0-102.028 22.02c20.481-150.9 40.579-241.72 44.243-279.57h45.226c-.14 57.15 11.801 171.93 12.559 257.55",
    style: {
      fill: "#3b2489",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5535.805 1383.784c0-70.16-64.312-127.02-143.691-127.02-79.391 0-143.746 56.86-143.746 127.02 0 70.1 64.355 126.94 143.746 126.94 79.379 0 143.691-56.84 143.691-126.94",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5679.523 1292.774c32.062 0 45.039 28.51 45.039 54.21h-90.078c0-25.7 14.34-54.21 45.039-54.21",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5710.008 1408.705c0-8.27-6.539-15.02-14.554-15.02-8.016 0-14.567 6.75-14.567 15.02 0 8.3 6.551 15.05 14.567 15.05 8.015 0 14.554-6.75 14.554-15.05",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5716.922 1412.294c0-3.4-2.707-6.22-6.047-6.22-3.336 0-6.062 2.82-6.062 6.22 0 3.46 2.726 6.24 6.062 6.24 3.34 0 6.047-2.78 6.047-6.24",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5649.012 1408.705c0-8.27 6.489-15.02 14.528-15.02 8.035 0 14.574 6.75 14.574 15.02 0 8.3-6.539 15.05-14.574 15.05-8.039 0-14.528-6.75-14.528-15.05",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5642.097 1412.294c0-3.4 2.722-6.22 6.035-6.22 3.32 0 6.019 2.82 6.019 6.22 0 3.46-2.699 6.24-6.019 6.24-3.313 0-6.035-2.78-6.035-6.24",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5700.957 1271.544v-51.64h42.914v51.64h-42.914",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5631.453 1445.985c-13.68 0-25.461-4.89-31.336-12.01 0 0 14.695 8.35 31.336 8.35 17.465 0 31.352-8.35 31.352-8.35-5.887 7.12-17.649 12.01-31.352 12.01m-96.141 0c13.704 0 25.461-4.89 31.36-12.01 0 0-14.692 8.35-31.36 8.35-17.464 0-31.351-8.35-31.351-8.35 5.898 7.12 17.648 12.01 31.351 12.01",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5760.058 1211.864-34.903-4.23.117-77.44 115.348-31.96.258 121.62-80.82-7.99",
    style: {
      fill: "#f5f5f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5596.219 1211.864 31.997-4.23.062-77.44-115.336-30.05.258 119.71 83.019-7.99",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5760.058 1108.574h-34.903v103.29h34.903v-103.29m163.839 0h31.997v103.29h-31.997v-103.29",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5679.238 1219.854-39.262-53.66-31.758 46.63 33.063 5.71 37.957 1.32",
    style: {
      fill: "#c2c6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5679.238 1219.854-40.926-44.4-30.094 37.37 49.301 14.93 21.719-7.9",
    style: {
      fill: "#e6e6e6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5679.238 1219.854 39.305-53.66 32.078 46.78-41.676 6.88h-29.707",
    style: {
      fill: "#c2c6c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5679.238 1219.854 40.898-44.4 30.485 37.52-50.188 14.78-21.195-7.9",
    style: {
      fill: "#e6e6e6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5794.961 1122.915v-64.5c35.094-16.83 74.137-26.28 115.391-26.28 41.183 0 80.254 9.45 115.348 26.28v64.5h-230.739",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5681.172 1179.255c-.609-.02-1.129.52-1.129 1.18 0 .61.496 1.17 1.129 1.17.617.04 1.133-.52 1.133-1.17 0-.66-.516-1.18-1.133-1.18zm-3.222 1.18c.031-2.91 2.308-5.24 5.109-5.27v10.59c-2.848-.05-5.129-2.41-5.109-5.32",
    style: {
      fill: "#55c58f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5677.074 1181.645c.609.01 1.125-.53 1.144-1.18 0-.62-.496-1.16-1.144-1.16-.609 0-1.129.47-1.129 1.13 0 .68.469 1.21 1.129 1.21zm-2.211 4.11v-10.59c.023 0 .047-.02.047-.02.039 0 .039-.02.039-.02 2.848.07 5.129 2.42 5.078 5.36 0 2.93-2.305 5.27-5.117 5.27h-.047",
    style: {
      fill: "#80d3ab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5681.172 1181.604c-.633 0-1.129-.56-1.129-1.17 0-.66.52-1.2 1.129-1.18.617 0 1.133.52 1.133 1.18 0 .65-.516 1.21-1.133 1.17m4.098-2.3c.648 0 1.144.54 1.144 1.16-.019.65-.535 1.19-1.144 1.18-.66 0-1.129-.53-1.129-1.21 0-.66.52-1.13 1.129-1.13",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5681.219 1147.804c-.66 0-1.128.55-1.171 1.18 0 .66.511 1.2 1.171 1.2.594 0 1.133-.54 1.133-1.15 0-.68-.519-1.23-1.133-1.23zm-3.242 1.18c0-2.89 2.305-5.25 5.125-5.27v10.61c-2.863-.05-5.125-2.43-5.125-5.34",
    style: {
      fill: "#55c58f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5677.125 1150.205c.613 0 1.129-.54 1.129-1.16 0-.65-.516-1.21-1.129-1.21-.609 0-1.125.56-1.125 1.2 0 .63.469 1.17 1.125 1.17zm-2.211 4.12v-10.61h.098c2.812.02 5.098 2.38 5.07 5.33 0 2.92-2.297 5.3-5.117 5.28h-.051",
    style: {
      fill: "#80d3ab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5681.219 1150.185c-.66 0-1.171-.54-1.171-1.2.043-.63.511-1.18 1.171-1.18.614 0 1.133.55 1.133 1.23 0 .61-.539 1.15-1.133 1.15m4.094-2.351c.613 0 1.129.56 1.129 1.21 0 .62-.516 1.16-1.129 1.16-.656 0-1.125-.54-1.125-1.17 0-.64.516-1.2 1.125-1.2",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5586.156 1503.912s-17.152-19.589-108.223-25.015c0 0 24.563.107 25.949 16.405 0 0-18.475-15.65-72.533-19.91 0 0 4.272.38 6.323 19.91l-61.145-103.677s-47.602 172.023 99.195 181.847c78.539 5.245 103.051-17.719 113.164-34.282 10.621-17.358-2.73-35.278-2.73-35.278",
    style: {
      fill: "#e69962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.02942
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5606.039 1459.758s65.817-123.655 65.817-200.423c0 0 20.589 191.844-11.754 260.596-10.211 21.746-54.063 41.496-54.063-60.173",
    style: {
      fill: "#e69962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.30598
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5773.167 1456.622s-32.22-128.645-32.22-208.511c0 0-43.094 199.586-10.801 271.113 10.21 22.624 102.433 79.585 102.433-26.188",
    style: {
      fill: "#e69962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33207
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5564.222 863.875h-230.739v259.04h230.739v-259.04",
    style: {
      fill: "#6c5067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5850.39 1142.665a936.14 936.14 0 0 1-1.176-10.56l-.188.18s-15.586-126.2-18.316-197.18c-.277-7.44 29.672-17.16 31.836-10.04 5.804 19.29 14.285 76.97 20.09 119.53h.027l17.133 78.32 9.949 78.71c-56.316-5.16-56.789-37.43-59.355-58.96",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5794.441 1211.864s-66.23 11.472-58.555-93.93c0 0 23.055-12.3 47.852-12.3 0 0 16.668 13 17.871 22.74 0 0 45.551 27.82 10.297 73.25-7.954 10.24-17.465 10.24-17.465 10.24",
    style: {
      fill: "#6c5067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5563.894 856.115h-243.34v49.55h243.34v-49.55",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5868.769 957.664s67.668-20.36 121.832-37.29c0 0 22.722 1.93 37.8-1.83 14.852-3.69 29.497-25.99 18.563-24.63-33.473 4.14-48.652 3.06-48.652 3.06l-132.461 8.69 2.918 52m360.675 185.001c.352-2.94.754-6.63 1.176-10.56l.188.18s15.59-126.2 18.316-197.18c.281-7.44-29.672-17.16-31.836-10.04-5.801 19.29-14.285 76.97-20.09 119.53h-.031l-17.129 78.32-9.949 78.71c56.316-5.16 56.797-37.43 59.355-58.96",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5564.043 1211.864s63.871-2.68 58.555-93.93c0 0-23.055-12.3-47.852-12.3 0 0-16.668 13-17.867 22.74 0 0-45.555 27.82-10.301 73.25 7.953 10.24 17.465 10.24 17.465 10.24",
    style: {
      fill: "#6c5067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5489.711 957.664s-67.672-20.36-121.828-37.29c0 0-22.738 1.93-37.801-1.83-14.859-3.69-29.504-25.99-18.57-24.63 33.473 4.14 48.652 3.06 48.652 3.06l132.461 8.69-2.914 52",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5552.87 513.193c-3.77 9.59-80.1 14.35-96.79 2.81-5.28-3.67-8.25-27.83-8.25-27.83h109.87s-1.84 17.44-4.83 25.02",
    style: {
      fill: "#262626",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5548.04 475.443h-109.87v12.73h109.87v-12.73m-246.06 37.75c3.77 9.59 80.1 14.35 96.8 2.81 5.27-3.67 8.26-27.83 8.26-27.83h-109.88s1.83 17.44 4.82 25.02",
    style: {
      fill: "#262626",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5798.92 475.443h109.88v12.73h-109.88v-12.73",
    style: {
      fill: "#262626",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 335.836 96.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.193 124.896h1.743v-13.899h-1.743v13.899",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.88 113.762H20.47v-4.033h28.41v4.033",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.936 111.745H19.85v-2.89h30.086v2.89",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4692.19 960.25c0-79.738-64.61-144.371-144.36-144.371-79.73 0-144.33 64.633-144.33 144.371 0 79.71 64.6 144.32 144.33 144.32 79.75 0 144.36-64.61 144.36-144.32",
    style: {
      fill: "#72bdc4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 -167.929 88.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4626.64 1131.02c-6.04 2.53-12.97-.34-15.47-6.35-2.54-6.04.28-12.97 6.35-15.49 61.37-25.66 101-84.78 101-150.649 0-90.152-74.22-163.492-165.45-163.492-29.34 0-58.11 7.68-83.27 22.172-5.66 3.238-12.85 1.289-16.13-4.379-3.28-5.66-1.33-12.891 4.34-16.172 22.63-13.031 47.81-21.109 73.81-24.019V752.07c-24.81-6.66-44.5-25.738-51.94-50.172h142.64c-8.17 26.602-30.74 46.911-58.65 51.672v18.129c99.29 5.571 178.38 87.231 178.38 186.832 0 75.449-45.41 143.129-115.61 172.489",
    style: {
      fill: "#00a651",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 -167.929 88.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4419.24 952.48h59.04c.43-16.66 2.11-32.5 4.94-47.07-12.89-3.031-24.74-6.988-35.29-11.801-.98-.461-2.05-.929-3.07-1.398-.68-.359-1.29-.711-1.93-1-1.02-.531-1.97-.992-2.91-1.5-12.36 18.789-19.42 40.309-20.78 62.769zm20.78 78.26c.92-.52 1.89-.96 2.87-1.46.66-.3 1.29-.65 1.97-1.04 1.02-.43 2.07-.94 3.07-1.39 10.55-4.78 22.4-8.76 35.29-11.79-2.83-14.59-4.51-30.412-4.94-47.048h-59.04c1.36 22.418 8.42 43.918 20.78 62.728zm71.15 52.85c-10.29-12.99-18.73-31.32-24.53-53.32-8.36 1.98-16.27 4.32-23.57 7.07-.3.12-.63.24-.9.36-1.51.58-2.95 1.21-4.38 1.79-.58.24-1.13.49-1.68.71-1.19.5-2.34 1.03-3.45 1.58-.65.29-1.29.58-1.92.9-.45.23-.86.42-1.35.68 16.27 19.14 37.97 33.09 61.78 40.23zm36.66 5.49c19.14 0 36.31-25.08 45.98-61.89a253.2 253.2 0 0 0-15-2.05c-.12 0-.22-.04-.33-.04-2.25-.28-4.5-.47-6.8-.63-.31-.06-.65-.07-.98-.1-2.03-.17-4.12-.31-6.23-.42-.51-.02-.95-.08-1.44-.1-1.98-.06-3.95-.16-5.98-.24-.59-.02-1.11-.04-1.68-.06-2.5-.07-5.02-.07-7.54-.07-2.5 0-5.02 0-7.56.07-.54.02-1.11.04-1.62.06-2.05.08-4.04.18-5.99.24-.53.02-1 .08-1.47.1-2.11.11-4.18.25-6.23.42-.35.03-.64.04-1 .1-2.28.16-4.53.35-6.75.63-.14 0-.26.04-.36.04-5.09.54-10.09 1.25-15 2.07 9.65 36.79 26.82 61.87 45.98 61.87zm98.44-45.72c-.45-.26-.9-.45-1.33-.68-.64-.32-1.31-.61-1.93-.9-1.12-.55-2.27-1.1-3.44-1.58-.57-.22-1.11-.47-1.66-.71-1.43-.58-2.91-1.21-4.43-1.79-.28-.12-.57-.24-.88-.36-7.27-2.75-15.2-5.09-23.6-7.07-5.78 22-14.2 40.33-24.49 53.32 23.81-7.14 45.51-21.09 61.76-40.23zm4.55-15.08c.66.31 1.25.63 1.86.96.99.49 2.05.96 3 1.5 12.33-18.81 19.38-40.31 20.73-62.728h-59.01c-.41 16.636-2.13 32.458-4.94 47.068 11.66 2.71 22.48 6.19 32.13 10.37.14.06.25.1.41.15.82.4 1.64.75 2.44 1.12 1.15.53 2.29 1.01 3.38 1.56zm4.86-138.569a84.286 84.286 0 0 1-3.02 1.539c-.59.309-1.2.648-1.84.898-1.09.571-2.25 1.071-3.38 1.602-.84.371-1.62.742-2.44 1.129-.18.019-.31.082-.47.16-9.69 4.16-20.49 7.641-32.07 10.371 2.81 14.57 4.53 30.41 4.94 47.07h59.01c-1.35-22.46-8.4-43.98-20.73-62.769zm-71.17-52.84c10.29 12.949 18.71 31.348 24.49 53.328 8.42-1.98 16.43-4.379 23.7-7.129.21-.101.39-.16.54-.218 1.62-.622 3.24-1.27 4.79-1.911.47-.222.9-.41 1.35-.589 1.26-.571 2.51-1.133 3.76-1.704a28.2 28.2 0 0 1 1.68-.796c.49-.25.96-.493 1.43-.743-16.23-19.14-37.93-33.089-61.74-40.238zm-36.68-5.48c-19.12 0-36.33 25.058-45.98 61.89 4.91.821 9.97 1.5 15.08 2.051.04.039.14.039.22.059 2.24.211 4.55.449 6.91.629.29 0 .55.031.86.07 2.09.18 4.16.32 6.31.39.47.04.94.079 1.43.102 1.95.117 3.94.199 5.99.27.55.019 1.08.019 1.62.046 2.54.071 5.06.114 7.56.114 2.52 0 5.04-.043 7.54-.114.57-.027 1.09-.027 1.66-.046 2.05-.071 4.02-.153 6-.27.49-.023.93-.062 1.44-.102 2.11-.07 4.2-.21 6.29-.39.27-.039.59-.07.86-.07 2.31-.18 4.67-.418 6.95-.629.02-.02.12-.02.16-.059 5.1-.531 10.16-1.23 15.08-2.051-9.67-36.832-26.86-61.89-45.98-61.89zm-54.02 136.621c.39 15.488 2.03 30.308 4.65 43.978 3.69-.62 7.46-1.17 11.27-1.66.09 0 .21-.02.29-.04 2.3-.29 4.61-.54 6.93-.76.35-.06.73-.1 1.08-.12 2.11-.19 4.22-.39 6.36-.56.67-.06 1.39-.08 2.06-.1 1.83-.16 3.69-.27 5.5-.39 1.27-.04 2.52-.1 3.77-.16 1.35-.02 2.7-.11 4.08-.15 2.68-.06 5.36-.12 8.03-.12 2.7 0 5.37.06 8.05.12 1.37.04 2.69.13 4.02.15 1.29.06 2.54.12 3.81.16 1.84.12 3.61.21 5.43.39.72.02 1.45.04 2.19.1 2.11.17 4.16.37 6.19.55.43.03.82.07 1.23.13 2.28.22 4.53.47 6.82.76.11 0 .25.04.41.04 3.8.49 7.55 1.04 11.25 1.66 2.63-13.67 4.23-28.49 4.62-43.978zm108.04-15.532c-.39-15.511-1.99-30.332-4.62-44-3.7.622-7.45 1.149-11.23 1.661-.18 0-.32.019-.45.039-2.27.269-4.52.5-6.8.781-.41.039-.8.059-1.23.09-2.03.199-4.08.398-6.19.57-.74.039-1.47.098-2.19.121-1.82.129-3.59.25-5.43.348-1.27.101-2.52.121-3.81.16-1.33.051-2.65.109-4.02.129-2.68.101-5.35.121-8.05.121-2.69 0-5.35-.02-8.03-.121-1.38-.02-2.73-.098-4.08-.149-1.25-.019-2.5-.039-3.77-.14-1.81-.098-3.67-.219-5.5-.348-.67-.023-1.39-.082-2.06-.121-2.14-.172-4.23-.391-6.32-.57-.39-.031-.77-.051-1.12-.09-2.32-.281-4.63-.512-6.91-.781-.1-.02-.22-.039-.31-.039-3.81-.512-7.58-1.039-11.27-1.661-2.62 13.668-4.26 28.489-4.65 44zm-152.46-75.371c.53.25 1 .512 1.51.743.53.269 1.03.488 1.6.777 1.25.59 2.54 1.152 3.83 1.742.41.16.88.348 1.27.551 1.58.66 3.22 1.308 4.84 1.949.16.059.33.098.53.199 7.3 2.75 15.27 5.149 23.67 7.129 5.8-21.98 14.26-40.379 24.53-53.328-23.81 7.149-45.51 21.098-61.78 40.238zm-22.89 4.532 4.89-6.68c0-.02.04-.102.06-.102l4.21-5.757.22.097c27.28-33.519 68.59-53.32 111.95-53.32s84.65 19.801 111.99 53.32l.16-.058 4.26 5.718s.06.082.06.102l4.9 6.68-.27.16c15.17 23.398 23.26 50.308 23.26 78.449 0 28.109-8.09 55.02-23.26 78.4l.27.18-4.9 6.72c-.06 0-.06.05-.06.05l-4.26 5.79-.16-.14c-27.34 33.48-68.63 53.34-111.99 53.34s-84.67-19.86-111.95-53.34l-.22.14-4.21-5.79c-.02 0-.02-.05-.06-.07l-4.89-6.7.26-.18c-15.22-23.4-23.26-50.291-23.26-78.4 0-28.141 8.04-55.051 23.26-78.449l-.26-.16",
    style: {
      fill: "#00a651",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05187 0 0 -.05187 -167.929 88.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.009 111.006h-9.43v-1.92h9.43v1.92",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(3.077 -110.636) scale(1.47031)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher2);
export default __webpack_public_path__ + "static/media/teacher2.6dabf6549afd71a5134b80e895fb7488.svg";
export { ForwardRef as ReactComponent };